class UrlUtils {
  static isValidUrl(urlInput) {
    if (urlInput === undefined || urlInput === "") return true;
    var urlPattern = new RegExp(
      "^(https?:\\/\\/)?" +
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
        "((\\d{1,3}\\.){3}\\d{1,3}))" +
        "(\\:\\d+)?" +
        "(\\/[-a-z\\d%@_.~+&:]*)*" +
        "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" +
        "(\\#[-a-z\\d_]*)?$",
      "i"
    );
    return urlPattern.test(urlInput);
  }

  static getYoutubeVideoId(urlInput) {
    if (!this.isValidUrl(urlInput)) return "";

    let id = "";

    if (urlInput.includes("youtube.com")) {
      if (urlInput.includes("?v=")) {
        id = urlInput.split("?v=")[1].split("&")[0];
      } else if (urlInput.includes("&v=")) {
        id = urlInput.split("&v=")[1].split("&")[0];
      } else if (urlInput.includes("/embed/")) {
        id = urlInput.split("/embed/")[1].split("?")[0];
      } else if (urlInput.includes("/shorts/")) {
        id = urlInput.split("/shorts/")[1].split("?")[0];
      }
    } else if (urlInput.includes("youtu.be/")) {
      id = urlInput.split("youtu.be/")[1].split("?")[0];
    }

    return id.length === 11 ? id : "";
  }

  static getWistiaVideoId(urlInput) {
    if (!this.isValidUrl(urlInput)) return "";
    if (urlInput.search("wistia.com\\/") != -1) {
      // id is the last subpath
      let id = urlInput.split("/").pop();
      if (id.search("\\?wtime=") != -1) {
        // remove starting time if specified
        let splitIndex = id.lastIndexOf("?");
        id = id.substring(0, splitIndex);
      }
      return id;
    } else {
      return "";
    }
  }
}

export default UrlUtils;



// WEBPACK FOOTER //
// ./src/layout/utils/urlUtils.js